module.exports = __webpack_public_path__ + "img/workshops.b6c8a903.svg";